import { convertToDays } from "@oysterhr/advisor"
import {
  CalendarDurationType,
  CountryIntelligenceOysterScore,
  CountryIntelligenceRulesTimeOff,
  CountryIntelligenceRulesTimeOffType,
} from "@oysterhr/schema"

export const getMinimumVacationDays = (timeOffRules?: CountryIntelligenceRulesTimeOff[]) => {
  if (!timeOffRules?.length) return null

  const statutoryVacationRules = timeOffRules.filter(
    rule =>
      rule.type === CountryIntelligenceRulesTimeOffType.Vacations &&
      rule.oysterScore === CountryIntelligenceOysterScore.Statutory,
  )
  if (!statutoryVacationRules.length) return 0

  return statutoryVacationRules
    .map(rule => rule.amountPerYear)
    .map(duration =>
      convertToDays(duration?.unit || CalendarDurationType.Days, duration?.value || 0),
    )
    .reduce((minDays, days) => Math.min(minDays, days))
}
